export default "__VITE_ASSET__CMMbrdYA__"